import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '@/app/layout/AppShell';
import { ApiError } from '@/lib/api-client';
import { fetchCurrentUser } from '@/lib/auth';
import { isNative, profileSync } from '@/lib/native-auth';

// Layout autenticado. Carrega usuário atual; redireciona pra /auth/login
// (servida pelo server.js, com Google + email/senha) se 401. NÃO usar a
// rota SPA /login na web porque ela mostra um form sem botão Google.
// No app nativo (bundle-mode): offline renderiza do perfil em cache e só
// 401 real / sem-cache manda pro login SPA embarcado.
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    try {
      const user = await context.queryClient.fetchQuery({
        queryKey: ['auth', 'me'],
        queryFn: ({ signal }) => fetchCurrentUser(signal),
        staleTime: 5 * 60_000,
      });
      return { user };
    } catch (e) {
      const isAuthErr = e instanceof ApiError && e.status === 401;
      if (isNative()) {
        // Offline (erro de rede, não 401): usa o perfil persistido.
        if (!isAuthErr) {
          const cached = profileSync();
          if (cached) {
            context.queryClient.setQueryData(['auth', 'me'], cached);
            return { user: cached };
          }
        }
        throw redirect({ to: '/login' });
      }
      // Web: comportamento original (só 401 redireciona; rede rethrow).
      if (isAuthErr) {
        if (typeof window !== 'undefined') {
          const target = `/auth/login?redirect=${encodeURIComponent(location.href)}`;
          window.location.replace(target);
        }
        throw new Error('redirecting-to-auth');
      }
      throw e;
    }
  },
  component: AppShell,
});
